import { WorkOrderChangeStatusEnum } from 'gql/graphql';
import { IconWarning, Informer } from 'uikit';

import { noun } from 'plural-ru';
import { useCallback, useImperativeHandle, useEffect, useMemo } from 'react';
import type { MutableRefObject } from 'react';
import type React from 'react';

import { useUerWorkOrderChangeDraftInfo } from './hooks/useUerWorkOrderChangeDraftInfo';

interface IWorkOrderChangeDraftInformer {
    workOrderChangeId: number;
    status?: WorkOrderChangeStatusEnum;
    refreshDraftInfoRef: MutableRefObject<{ refreshDraftInfo: () => void } | undefined>;
}
export const WorkOrderChangeDraftInformer: React.FC<IWorkOrderChangeDraftInformer> = (props) => {
    const { workOrderChangeId, status, refreshDraftInfoRef } = props;

    const { uerWorkOrderChangeDraftInfoData, uerWorkOrderChangeDraftInfoRefresh } = useUerWorkOrderChangeDraftInfo();

    const doRefresh = useCallback(() => {
        if (status === WorkOrderChangeStatusEnum.OnFormation) {
            uerWorkOrderChangeDraftInfoRefresh(workOrderChangeId);
        }
    }, [status, uerWorkOrderChangeDraftInfoRefresh, workOrderChangeId]);

    useEffect(() => {
        doRefresh();
    }, [doRefresh, status, uerWorkOrderChangeDraftInfoRefresh, workOrderChangeId]);

    useImperativeHandle(refreshDraftInfoRef, () => ({ refreshDraftInfo: doRefresh }), [doRefresh]);

    const msg = useMemo(() => {
        const draftCount = uerWorkOrderChangeDraftInfoData?.uerWorkOrderChangeDraftInfo?.data?.draftCount || 0;

        return draftCount
            ? `${draftCount} ${noun(draftCount, ...['запись', 'записи', 'записей'])}  в статусе черновик`
            : '';
    }, [uerWorkOrderChangeDraftInfoData?.uerWorkOrderChangeDraftInfo?.data?.draftCount]);

    return status === WorkOrderChangeStatusEnum.OnFormation && msg ? (
        <Informer
            label={msg}
            status="alert"
            view="filled"
            size="s"
            icon={IconWarning}
            className="workOrderDraftInformer"
        />
    ) : (
        <div />
    );
};

WorkOrderChangeDraftInformer.displayName = 'WorkOrderChangeDraftInformer';
